export const USER_CHANNEL_NAME = 'UserChannel'

export const USER_CHANNEL = { channel: USER_CHANNEL_NAME }
